import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { useAuthOrigin } from './useAuthOrigin'

type Options = {
  code: string
  clientId: string
  redirectUrl: URL
  verifier: string
}

export function useTokens() {
  const $httpFetch = useHttpFetch()

  async function getTokens(options: Options) {
    const body = new URLSearchParams({
      grant_type: 'authorization_code',
      code: options.code,
      client_id: options.clientId,
      redirect_uri: options.redirectUrl.href,
      code_verifier: options.verifier,
    })

    const payload = await $httpFetch('/oauth2/token', {
      method: 'POST',
      baseURL: useAuthOrigin(),
      body,
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
      },
    })

    return {
      accessToken: payload.access_token,
      refreshToken: payload.refresh_token,
    }
  }

  return { getTokens }
}
